<template>
  <div id="dashboard">
    <nav-bar-top />
    <dashboard-candidate v-if="account.user_type === 'candidate'" />
    <dashboard-company v-if="account.user_type === 'company'" />
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';
import DashboardCandidate from '@/components/Dashboard/DashboardCandidate';
import DashboardCompany from '@/components/Dashboard/DashboardCompany';

export default {
  name: 'Dashboard',
  components: {
    DashboardCandidate,
    DashboardCompany,
    NavBarTop
  },
  computed: {
    account () {
      return this.$store.state.user.account;
    }
  }
};
</script>

<style lang="scss">
</style>
